var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 18.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a6672;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.77,17.78l-4.29-3.29c-.41-.31-.97-.31-1.38,0l-4.33,3.29c-.32.26-.75.32-1.12.15-.37-.16-.62-.51-.65-.92V2.95c.04-.82.4-1.59,1.02-2.15C1.63.25,2.44-.04,3.26,0h7c.83-.03,1.64.26,2.25.83.61.56.97,1.34.99,2.17v14.01c-.04.39-.28.73-.64.89-.36.16-.77.12-1.09-.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/Registered.f0a13a067092fb5426a8b681fab869a2.svg";
export { ForwardRef as ReactComponent };